import { PublicApiClient } from '@/services/PublicApiClient'
import { RetailerApiClient } from '@/services/RetailerApiClient.js'

export default {
  calculatePrice(params) {
    return RetailerApiClient
      .post('machines/romania/price-calculator/calculate-prices', params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createApplication(params) {
    return RetailerApiClient
      .post('machines/romania/application/start', params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  completeApplication(applicationId) {
    return RetailerApiClient
      .post(`machines/romania/application/${applicationId}/complete`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  saveFarmerInfoSurveyAnswers(applicationId, params) {
    return RetailerApiClient
      .post(`machines/romania/application/${applicationId}/farmer-info-survey`, params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  saveSurveyAnswers(applicationId, params) {
    return RetailerApiClient
      .post(`machines/romania/application/${applicationId}/survey`, params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  uploadDocument(applicationId, file) {
    let formData = new FormData()
    formData.append('file', file.file)
    formData.append('type', file.type)

    return RetailerApiClient.postForm('applications/' + applicationId + '/upload-document', formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  uploadMultipleDocument(applicationId, formData) {
    return RetailerApiClient.postForm(`applications/${applicationId}/upload-order-document-page`, formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteDocumentPage(applicationId, document, page) {
    return RetailerApiClient.delete(`applications/${applicationId}/documents/${document.id}/pages/${page.id}`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  viewDocumentPage(applicationId, document, page) {
    return RetailerApiClient.get(`applications/${applicationId}/documents/${document.id}/pages/${page.id}`, {
      responseType: 'arraybuffer'
    })
      .then(response => {
        let blob = new Blob([response], { type: page.content_type })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  viewDocument(applicationId, document) {
    return RetailerApiClient.get('applications/' + applicationId + '/documents/' + document.id, {
      responseType: 'arraybuffer'
    })
      .then(response => {
        let blob = new Blob([response], { type: document.content_type })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  getLatestUploadedDocuments(applicationId) {
    return RetailerApiClient.get('applications/' + applicationId + '/latest-uploaded-documents')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getUnMergedDocuments(applicationId) {
    return RetailerApiClient.get('applications/' + applicationId + '/unmerged-uploaded-documents')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getQrCode(applicationId) {
    return RetailerApiClient.get(`applications/${applicationId}/generate-qr-for-required-documents`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  saveDocuments(applicationId, params) {
    return RetailerApiClient
      .post(`machines/romania/application/${applicationId}/documents`, params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  uploadPublicOrderDocumentPage(hash, formData) {
    return PublicApiClient.postForm(`applications/${hash}/upload-order-document-page`, formData)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      })
  },
  toggleFarmerDocumentStatus(hash, params) {
    return PublicApiClient.patch(`applications/${hash}/toggle-farmer-document-upload-status`, params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getPublicApplicationDocuments(hash) {
    return PublicApiClient.get(`applications/${hash}/application-documents`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      })
  },
  viewPublicDocumentPage(hash, document, page) {
    return PublicApiClient.get(`applications/${hash}/documents/${document.id}/pages/${page.id}`, {
      responseType: 'arraybuffer'
    })
      .then(response => {
        let blob = new Blob([response.data], { type: page.content_type })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  viewPublicDocument(hash, document) {
    return PublicApiClient.get(`applications/${hash}/documents/${document.id}`, {
      responseType: 'arraybuffer'
    })
      .then(response => {
        let blob = new Blob([response.data], { type: document.content_type })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  deletePublicOrderDocumentPage(hash, document, page) {
    return PublicApiClient.delete(`applications/${hash}/documents/${document.id}/pages/${page.id}`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
